import { Modal, Stack } from '@hotjar/hotsauce';
import type { ComponentProps } from 'react';
import { ResponseModal as ResponseModalBase } from '@hotjar/feedback/components/common/ResponseModal';
import { useTranslation } from '@hotjar/translations';
import type { QuestionWithAnswers } from './domain/QuestionAnswerMapper';
import { ModalContent } from './ModalContent';
import { SurveyRecording } from '../../SurveyView/SurveyResponsesView/ResponsesList/SurveyRecording';

interface ResponseModalProps extends Omit<ComponentProps<typeof ResponseModalBase>, 'children'> {
  questionsWithAnswers: Record<string, QuestionWithAnswers>;
  responseIndex: number;
  coveragePercentage: number;
  isExternalLinkSurvey: boolean;
  recordingUrl: string | null;
  contentsquareUrl: string | null;
  siteId?: number;
}

export function ResponseModal({
  questionsWithAnswers,
  responseIndex,
  coveragePercentage,
  isExternalLinkSurvey,
  recordingUrl,
  contentsquareUrl,
  siteId,
  ...props
}: ResponseModalProps): JSX.Element {
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-response.modal' });
  return (
    <ResponseModalBase {...props}>
      <Modal.Header title={t('title', { responseIndex })} />
      <Modal.Body>
        <ModalContent questionsWithAnswers={questionsWithAnswers} />
      </Modal.Body>
      {!isExternalLinkSurvey && (
        <Modal.Footer>
          <Stack spacing="x1">
            <SurveyRecording
              recordingUrl={recordingUrl}
              coveragePercentage={coveragePercentage}
              contentsquareUrl={contentsquareUrl}
              siteId={siteId}
              type="button"
              trackUiPosition="survey_response_modal_view_play_button"
            />
          </Stack>
        </Modal.Footer>
      )}
    </ResponseModalBase>
  );
}
